<div class="modal-header" qaDependencyDrag>
  <div><h4 [id]="titleId">{{_(part.kind === 'condition' ? KEYS.EDITOR.FORMULA_IF_THEN : KEYS.EDITOR.FORMULA_FUNCTION)}}</h4>
    <span class="text-muted">{{part.kind === 'function' ? part.name : _(KEYS.EDITOR.FORMULA_BRANCH_HINT)}}</span></div>
  <button type="button" class="close" [attr.aria-label]="_(KEYS.EDITOR.CLOSE)" (click)="activeModal.dismiss()">×</button>
</div>
<div class="modal-body">
  <div *ngFor="let field of part.fields; let index = index; trackBy: trackIndex" class="mb-3">
    <app-qa-formula-input [value]="field" (valueChange)="part.fields[index] = $event" [variables]="variables"
      [label]="fieldLabel(index)" [compact]="true" (saveRequested)="apply()"></app-qa-formula-input>
    <button type="button" class="btn btn-sm btn-link" *ngIf="variadic() && part.fields.length > 1"
      (click)="part.fields.splice(index, 1)">{{_(KEYS.EDITOR.FORMULA_REMOVE_ARGUMENT)}}</button>
  </div>
  <button type="button" class="btn btn-outline-secondary btn-sm" *ngIf="variadic()" (click)="part.fields.push('0')">+ {{_(KEYS.EDITOR.FORMULA_ARGUMENT)}}</button>
  <p *ngIf="!part.fields.length" class="text-muted">{{_(KEYS.EDITOR.FORMULA_NO_ARGUMENTS)}}</p>
  <p *ngIf="issue()" role="status" class="text-danger mt-2">{{_(issue())}}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">{{_(KEYS.EDITOR.TEXT_VARIABLE_CANCEL)}}</button>
  <button type="button" class="btn btn-primary" [disabled]="!!issue()" (click)="apply()">{{_(KEYS.EDITOR.FORMULA_APPLY)}}</button>
</div>
